import React from "react";
import "../../../styles/PriceFilter.css";
import { Slider, Typography } from "antd";


const { Text } = Typography;


export default function PriceFilter({ value = [0, 30000], onChange }) {
  const [minValue, maxValue] = value;

  const handleSliderChange = (newRange) => {
    onChange(newRange);
  };

  const handleMinInput = (e) => {
    const parsed = parseInt(e.target.value.replace(/,/g, ""), 10) || 0;
    onChange([parsed, maxValue]);
  };

  const handleMaxInput = (e) => {
    const parsed = parseInt(e.target.value.replace(/,/g, ""), 10) || 0;
    onChange([minValue, parsed]);
  };

  return (
    <div className="price-filter-container">
      <Text strong>Rango de precio:</Text>
      <Slider
        range
        min={0}
        max={100000}
        step={100}
        value={[minValue, maxValue]}
        onChange={handleSliderChange}
        tooltip={{
          open: false,
          formatter: (val) =>
            new Intl.NumberFormat("es-MX", {
              style: "currency",
              currency: "MXN",
              maximumFractionDigits: 0,
            }).format(val),
        }}
      />

      <div className="price-filter-inputs">
        <input
          type="text"
          value={minValue.toLocaleString()}
          onChange={handleMinInput}
          className="price-filter-input price-input-small"
        />
        <span> – </span>
        <input
          type="text"
          value={maxValue.toLocaleString()}
          onChange={handleMaxInput}
          className="price-filter-input price-input-small"
        />
      </div>
    </div>
  );
}
